import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { ShopProvider } from "@/context/ShopContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import OfferStrip from "@/components/OfferStrip";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Wishlist from "@/pages/Wishlist";
import Checkout from "@/pages/Checkout";
// Ye pages tabhi download hote hain jab customer inpe jaata hai (pehla load halka rehta hai)
const OrderTracking = React.lazy(() => import("@/pages/OrderTracking"));
const Account = React.lazy(() => import("@/pages/Account"));
const Story = React.lazy(() => import("@/pages/Story"));
const Terms = React.lazy(() => import("@/pages/Terms"));
const Privacy = React.lazy(() => import("@/pages/Privacy"));
const Returns = React.lazy(() => import("@/pages/Returns"));
const SizeGuide = React.lazy(() => import("@/pages/SizeGuide"));
const Login = React.lazy(() => import("@/pages/Login"));
const Signup = React.lazy(() => import("@/pages/Signup"));
const AdminLogin = React.lazy(() => import("@/pages/admin/AdminLogin"));
const AdminLayout = React.lazy(() => import("@/pages/admin/AdminLayout"));
const AdminDashboard = React.lazy(() => import("@/pages/admin/AdminDashboard"));
const AdminProducts = React.lazy(() => import("@/pages/admin/AdminProducts"));
const AdminOrders = React.lazy(() => import("@/pages/admin/AdminOrders"));
const AdminReturns = React.lazy(() => import("@/pages/admin/AdminReturns"));
const AdminCoupons = React.lazy(() => import("@/pages/admin/AdminCoupons"));
const AdminNewsletter = React.lazy(() => import("@/pages/admin/AdminNewsletter"));

const ScrollToTop = () => {
    const { pathname } = useLocation();
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const StorefrontChrome = ({ children }) => {
    const loc = useLocation();
    const isAdmin = loc.pathname.startsWith("/admin");
    return (
        <>
            {!isAdmin && <OfferStrip />}
            {!isAdmin && <Header />}
            <main data-testid="main-content">{children}</main>
            {!isAdmin && <Footer />}
        </>
    );
};

function App() {
    return (
        <CustomerAuthProvider>
            <ShopProvider>
            <AdminAuthProvider>
                <div className="App">
                    <BrowserRouter>
                        <ScrollToTop />
                        <StorefrontChrome>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/shop" element={<Shop />} />
                                <Route path="/shop/:filter" element={<Shop />} />
                                <Route path="/product/:id" element={<ProductDetail />} />
                                <Route path="/cart" element={<Cart />} />
                                <Route path="/wishlist" element={<Wishlist />} />
                                <Route path="/checkout" element={<Checkout />} />
                                <Route path="/track" element={<OrderTracking />} />
                                <Route path="/track/:orderNumber" element={<OrderTracking />} />
                                <Route path="/account" element={<Account />} />
                                <Route path="/story" element={<Story />} />
                                <Route path="/terms" element={<Terms />} />
                                <Route path="/privacy" element={<Privacy />} />
                                <Route path="/returns" element={<Returns />} />
                                <Route path="/size-guide" element={<SizeGuide />} />                                <Route path="/story" element={<Story />} />
                                <Route path="/terms" element={<Terms />} />
                                <Route path="/terms" element={<Terms />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/signup" element={<Signup />} />

                                {/* Admin */}
                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route path="/admin" element={<AdminLayout />}>
                                    <Route index element={<AdminDashboard />} />
                                    <Route path="products" element={<AdminProducts />} />
                                    <Route path="orders" element={<AdminOrders />} />
                                    <Route path="returns" element={<AdminReturns />} />
                                    <Route path="coupons" element={<AdminCoupons />} />
                                    <Route path="newsletter" element={<AdminNewsletter />} />
                                </Route>
                            </Routes>
                        </StorefrontChrome>
                        <Toaster
                            position="top-center"
                            toastOptions={{
                                style: {
                                    background: "#FBF5E9",
                                    border: "1px solid rgba(201,162,39,0.4)",
                                    color: "#2A161A",
                                    fontFamily: "Lora, serif",
                                },
                            }}
                        />
                    </BrowserRouter>
                </div>
            </AdminAuthProvider>
            </ShopProvider>
        </CustomerAuthProvider>
    );
}

export default App;
